import bookReviewLogin from './book-reviews/account-page2.gif';
import bookReviewAccReviews from './book-reviews/account-reviews.gif';
import bookReviewReview from './book-reviews/review-caption.gif';
import bookReviewSearch from './book-reviews/search-caption.gif';
import bookReviewSort from './book-reviews/sorting-caption.gif';
import blackJackLogo from './blackjack-cropped.png';
import blackJackGif from './blackjack.gif';
import justOneLogo from './just-one.jpg';
import chat from './callsigns/chat.jpg';
import eliminateHint from './callsigns/eliminateHint.jpg';
import failscreen from './callsigns/failscreen.jpg';
import hint from './callsigns/hint.jpg';
import homepage from './callsigns/homepage.jpg';
import lobby from './callsigns/lobby.jpg';
import settings from './callsigns/settings.jpg';
import guess from './callsigns/voteHint.jpg';
import demo1 from './pokemon-team-builder/pokemonteambuilder1-speed.gif'

export const bookReviewImages = [
  bookReviewAccReviews,
  bookReviewLogin,
  bookReviewReview,
  bookReviewSearch,
  bookReviewSort,
];

export const callSignsImages = [
  eliminateHint,
  homepage,
  settings,
  lobby,
  hint,
  chat,
  // eliminateHint,
  guess,
  failscreen,
];

export const pokemonImages = [
  demo1
]


export {
  bookReviewAccReviews, bookReviewLogin, bookReviewReview, bookReviewSearch, bookReviewSort,
  blackJackGif, blackJackLogo, justOneLogo,
  chat, eliminateHint, failscreen, hint, homepage, lobby, settings, guess, demo1
};
